import {
  SHIRT_ACTIVE_FORMULA_VERSION,
  SHIRT_V1_FORMULA_VERSION,
  SHIRT_V2_FORMULA_VERSION,
  SHIRT_V3_FORMULA_VERSION,
} from '@/lib/patterns/shirt/siy_v1';

export const SHIRT_GEOMETRY_V1 = 'shirt_geom_v1';
export const SHIRT_GEOMETRY_V2 = 'shirt_geom_v2';
export const SHIRT_GEOMETRY_V3 = 'shirt_geom_v3';
export const SHIRT_ACTIVE_GEOMETRY_VERSION = SHIRT_GEOMETRY_V3;

export const SHIRT_FORMULA_TO_GEOMETRY = {
  [SHIRT_V1_FORMULA_VERSION]: SHIRT_GEOMETRY_V1,
  [SHIRT_V2_FORMULA_VERSION]: SHIRT_GEOMETRY_V2,
  [SHIRT_V3_FORMULA_VERSION]: SHIRT_GEOMETRY_V3,
};

export const SHIRT_GEOMETRY_TO_FORMULA = {
  [SHIRT_GEOMETRY_V1]: SHIRT_V1_FORMULA_VERSION,
  [SHIRT_GEOMETRY_V2]: SHIRT_V2_FORMULA_VERSION,
  [SHIRT_GEOMETRY_V3]: SHIRT_V3_FORMULA_VERSION,
};

export function resolveShirtGeometryVersionFromFormula(formulaVersion) {
  return SHIRT_FORMULA_TO_GEOMETRY[formulaVersion] || SHIRT_GEOMETRY_V2;
}

export function resolveShirtFormulaVersionFromGeometry(geometryVersion) {
  return SHIRT_GEOMETRY_TO_FORMULA[geometryVersion] || SHIRT_ACTIVE_FORMULA_VERSION;
}

export function migrateShirtPatternForward(patternLike = {}) {
  const explicitGeometry = String(patternLike?.geometry_version || '').toLowerCase();
  const explicitFormula = String(patternLike?.formula_version || '').toLowerCase();
  const geometryVersion = explicitGeometry === SHIRT_GEOMETRY_V1
    ? SHIRT_GEOMETRY_V1
    : explicitGeometry === SHIRT_GEOMETRY_V2
      ? SHIRT_GEOMETRY_V2
      : explicitGeometry === SHIRT_GEOMETRY_V3
        ? SHIRT_GEOMETRY_V3
        : explicitFormula === SHIRT_V1_FORMULA_VERSION
          ? SHIRT_GEOMETRY_V1
          : explicitFormula === SHIRT_V2_FORMULA_VERSION
            ? SHIRT_GEOMETRY_V2
            : explicitFormula === SHIRT_V3_FORMULA_VERSION
              ? SHIRT_GEOMETRY_V3
              : SHIRT_GEOMETRY_V2;

  return {
    ...patternLike,
    garment_type: patternLike?.garment_type || 'shirt',
    geometry_version: geometryVersion,
    formula_version: resolveShirtFormulaVersionFromGeometry(geometryVersion),
  };
}
